// 選單 - 熱門關鍵字
import { useState, useEffect } from 'react';
import bannerClient from '@/common/apiClient/bannerClient';
import Image from 'next/image';
import Link from 'next/link';
import { PROMO_BANNER_POSITION_CODE } from '@/common/constant';

const MenuKeyword = ({ t, keywords, locale }) => {
    // 背景
    const [banner, setBanner] = useState({});

    // 取得背景
    const getBanner = async () => {
        try {
            const { banners } = await bannerClient.getBanner(
                locale,
                PROMO_BANNER_POSITION_CODE.LIST_BACKGROUND
            );

            if (banners?.length) setBanner(banners[0]);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getBanner();
    }, []);

    return (
        <div className="space-y-[12px] text-center w-[173px] ulg:hidden">
            <p className="text-btn2 text-black6">{t('KEYWORD')}</p>

            {/* 關鍵字列表 */}
            {keywords?.map((word, i) => (
                <Link
                    href={`/search/${word}`}
                    key={word + 'keyword' + i}
                    className="border-1 border-black1 px-[15px] py-[12px] rounded-[4px] relative group block overflow-hidden"
                >
                    <span className="trans group-hover:text-white line-clamp-1 text-btn1 text-black4">
                        {word}
                    </span>

                    {/* 背景 */}
                    {banner?.img && (
                        <Image
                            src={banner?.img}
                            className="absolute top-0 left-0 w-full h-full z-[-1] opacity-0 trans group-hover:opacity-[1] object-cover object-center"
                            width={174}
                            height={42}
                            alt="background"
                        />
                    )}

                    <span className="absolute bg-cop w-full h-full top-0 left-0 z-[-1] opacity-0 trans group-hover:opacity-[.8]" />
                </Link>
            ))}
        </div>
    );
};

export default MenuKeyword;
